		/**
		 * @ngdoc service
		 * @name WcResponsiveTableModule.service:WcTableCollectionService
		 * @requires WcTableScopeService
		 * @description
		 * The WcTableCollectionService manages the collection of table operations, this service is responsible to get the
		 * collection information from the table.
 */

angular.module('WcResponsiveTableModule')
	.factory('WcTableCollectionService', function() {

        function WcTableCollectionService(WcTableScopeService) {
            this.WcTableScopeService = WcTableScopeService;
        	this.collection = [];
            this.rowKey = '';

            this.sortEnabled = false;
            this.filterEnabled = false;
        }

		/**
		 * @ngdoc method
		 * @name getCollection
		 * @methodOf WcResponsiveTableModule.service:WcTableCollectionService
		 * @returns {array} This array holds table collection values
		 * @description
		 * The method returns the table collection array.
		 */

		WcTableCollectionService.prototype.getCollection = function () {
			return this.collection;
		};

		/**
		 * @ngdoc method
		 * @name getCollectionLength
		 * @methodOf WcResponsiveTableModule.service:WcTableCollectionService
		 * @returns {integer} This integer value holds length of the collection array
		 * @description
		 * The method returns the collection length
		 */

		WcTableCollectionService.prototype.getCollectionLength = function () {
			return this.collection.length;
		};

		/**
		 * @ngdoc method
		 * @name getRowKey
		 * @methodOf WcResponsiveTableModule.service:WcTableCollectionService
		 * @returns {integer} This integer value holds the index of the array
		 * @description
		 * The method returns the index of the array
		 */

		WcTableCollectionService.prototype.getRowKey = function () {
			return this.rowKey;
		};

		/**
		 * @ngdoc method
		 * @name setCollection
		 * @methodOf WcResponsiveTableModule.service:WcTableCollectionService
		 * @param {array} newCollection This array holds the collection data
		 * @param {boolean} sorted This boolean value decides whether the collection is sorted or not
		 * @param {boolean} filtered This boolean value decides whether the collection is filtered or not
		 * @description
		 * The method set the collection to an array based on sorting and filtered value.
		 */

		WcTableCollectionService.prototype.setCollection = function (newCollection, sorted, filtered) {
			this.collection = newCollection;

			//need to broadcast out that our collection has changed so the filter directives can update
			if (sorted === undefined && filtered === undefined) {
				this.WcTableScopeService.tableScope.$broadcast('table.collection.update');
			}

			this.WcTableScopeService.tableScope.renderTable((sorted || filtered));
		};

		/**
		 * @ngdoc method
		 * @name setInitialCollection
		 * @methodOf WcResponsiveTableModule.service:WcTableCollectionService
		 * @param {array} initialCollection This array holds the collection data
		 * @description
		 * The method set the initial collection values to an array
		 */

		WcTableCollectionService.prototype.setInitialCollection = function (initialCollection) {
			this.collection = initialCollection;
		};

		/**
		 * @ngdoc method
		 * @name setRowKey
		 * @methodOf WcResponsiveTableModule.service:WcTableCollectionService
		 * @param {integer} newRowKey This integer value holds the new index of the array.
		 * @description
		 * The method set the new index to the current index value.
		 */

		WcTableCollectionService.prototype.setRowKey = function (newRowKey) {
			if (newRowKey) {
				this.rowKey = newRowKey;
			} else {
				this.rowKey = 'id';
				this.collection.forEach(angular.bind(this, function (obj, index) {
					obj[this.rowKey] = index;
				}));
			}
		};

        return WcTableCollectionService;
	}
);